/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { EmployeePayBasis } from '@gh/builder-shared-data';
import { ContextRoute, getContextRouteInitData } from '@gh/common-internal-shared';
import { EnumDictionary } from '@gh/common-shared';
import { getControlValue } from '@gh/core-ui';
import { assign } from 'lodash';
import { ContactDetailsEmployeeCommonFormState } from './contact-details-employee-common-form.service';

@Component({
  standalone: false,
  selector: 'gh-contact-details-employee-common-tab',
  templateUrl: 'contact-details-employee-common-tab.component.html',
})
export class ContactDetailsEmployeeCommonTabComponent implements OnInit {
  genders: EnumDictionary<any>;
  payrolls: EnumDictionary<any>;
  payBasis: EnumDictionary<any>;

  constructor(private route: ContextRoute,
              public form: ContactDetailsEmployeeCommonFormState,
              private changeDetectorRef: ChangeDetectorRef) {
  }

  get salaryPayBasis(): boolean {
    return getControlValue(this.form.group, 'salary.payBasis') === EmployeePayBasis.Salary;
  }

  get hourlyPayBasis(): boolean {
    return getControlValue(this.form.group, 'salary.payBasis') === EmployeePayBasis.Hourly;
  }

  ngOnInit(): void {
    assign(this, getContextRouteInitData(this.route));
  }

  onPayBasisChange(): void {
    this.changeDetectorRef.detectChanges();
  }

}
